import { render, staticRenderFns } from "./BuyersList.vue?vue&type=template&id=19dd0a88&scoped=true"
import script from "./BuyersList.vue?vue&type=script&lang=js"
export * from "./BuyersList.vue?vue&type=script&lang=js"
import style0 from "./BuyersList.vue?vue&type=style&index=0&id=19dd0a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dd0a88",
  null
  
)

export default component.exports